import React, { } from 'react'
import { MenuItem, Grid, TextField, FormHelperText, InputAdornment } from '@material-ui/core';
import { Field, ErrorMessage } from 'formik';
import DatePicker from '../DatePicker';
import Observers from '../Observers';
import { useStore } from '../../Store'
import { getErrorProps, getOptions, findPlot, observers } from '../../utils';

const VisitDetails = ({ readonly, formik }) => {

  const {plots, settings} = useStore()

  const plotItems = () => {
    return plots.map(item => {
      return (
        <MenuItem key={item.id} value={item.id}>
          {item.description}
        </MenuItem>
      )
    })
  }

  const updateDescription= (value) => {
      const description= (value && value.isValid() ? value.format('DD-MM-YYYY') : '')
      formik.setFieldValue('description',description)
  }

  return (
    <Grid container>

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="telgebied" variant="standard" name="plot" fullWidth {...getErrorProps(formik, "plot")} {...formik.getFieldProps('plot')} >
          {plotItems()}
        </TextField>
      </Grid>

      <Grid item xs={12} >
        <Field disabled={readonly} label="bezoekdatum" variant="standard" name="dateStart" fullWidth {...getErrorProps(formik, "dateStart")} component={DatePicker}
          onChange={updateDescription} />
      </Grid>

      <Grid item xs={12} >
        <TextField disabled={readonly} label="starttijd" variant="standard" name="timeStart" type="time" placeholder="hh:mm" fullWidth {...getErrorProps(formik, "timeStart")} {...formik.getFieldProps('timeStart')} />
      </Grid>

      <Grid item xs={12} >
        <TextField disabled={readonly} label="eindtijd" autoComplete="off" variant="standard" name="timeStop" type="time" placeholder="hh:mm" fullWidth {...getErrorProps(formik, "timeStop")} {...formik.getFieldProps('timeStop')} />
      </Grid>

      <Grid item xs={12} >
        <TextField disabled={readonly} label="temperatuur" variant="standard" name="extraInfo.temperatuur" type="number" fullWidth {...getErrorProps(formik, "extraInfo.temperatuur")} {...formik.getFieldProps('extraInfo.temperatuur')}
        InputProps={{
          endAdornment: <InputAdornment position="end">&#8451;</InputAdornment>
      }} />
      </Grid>

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="windkracht" variant="standard" name="extraInfo.windkracht" fullWidth  {...getErrorProps(formik, "extraInfo.windkracht")} {...formik.getFieldProps('extraInfo.windkracht')} >
          {getOptions(settings.lists["windkracht"])}
        </TextField>
      </Grid>

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="bewolking" variant="standard" name="extraInfo.bewolking" fullWidth  {...getErrorProps(formik, "extraInfo.bewolking")} {...formik.getFieldProps('extraInfo.bewolking')} >
          {getOptions(settings.lists["bewolking"])}
        </TextField>
      </Grid>

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="windrichting" variant="standard" name="windrichting" fullWidth  {...getErrorProps(formik, "extraInfo.windrichting")} {...formik.getFieldProps('extraInfo.windrichting')} >
          {getOptions(settings.lists["windrichting"])}
        </TextField>
      </Grid>

      <Grid item xs={12} >
        <TextField disabled={readonly} label="opmerkingen" multiline variant="standard" name="extraInfo.opm_bezoek" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.opm_bezoek")} {...formik.getFieldProps('extraInfo.opm_bezoek')} />
      </Grid>

      <Grid item xs={12} >
        <Field disabled={readonly} label="waarnemers" variant="standard" name="observers" options={observers(findPlot(plots, formik.values.plot), formik.values.roles)} fullWidth {...getErrorProps(formik, "observers")} component={Observers} />
        <FormHelperText error><ErrorMessage component="div" name="observers" /></FormHelperText>
      </Grid>

    </Grid>
  )
}


export default VisitDetails